import {put, call, takeLatest} from 'redux-saga/effects'

import {
    settingsAddCallbackSagaAC, settingsDeleteCallbackSagaAC, settingsEditUrlCallbackSagaAC,
    settingsSetCallbackDataAC,
    settingsSetCallbackDataSagaAC,
    settingsSetCallbackLoaderAC
} from "./settingsActionCreators";
import {addCallback, changeCallbackUrl, deleteCallback, getCallbackList} from "./settingsAPI";
import {typeCallbackDataItem} from "./settingsReducer";
import { errorGenerator, notificationCreator } from 'model/system/utils';



// ---------------------------------------------------------------------------------------------------------------------
// Saga set callback data
export function* settingsSetCallbackDataWorker (
    actionObject:{
        type: string,
        payload: {}
    }
) {

    yield put(settingsSetCallbackLoaderAC(true))

    let response = yield call(getCallbackList)

    if (response.status === 200) {
        yield put(settingsSetCallbackDataAC(response.data))
    } else {
        yield errorGenerator(response)
    }

    yield put(settingsSetCallbackLoaderAC(false))

}

export function* settingsSetCallbackDataWatcher () {
    yield takeLatest(settingsSetCallbackDataSagaAC.type, settingsSetCallbackDataWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Saga add callback
export function* settingsAddCallbackWorker (
    actionObject:{
        type: string,
        payload: {
            callbackObj: typeCallbackDataItem
        }
    }
) {

    yield put(settingsSetCallbackLoaderAC(true))

    let responseAdd = yield call(addCallback, { dataObject: actionObject.payload.callbackObj })

    if (responseAdd.status === 200) {

        yield notificationCreator('SUCCESS_ADD_CALLBACK')

        let response = yield call(getCallbackList)

        if (response.status === 200) {
            yield put(settingsSetCallbackDataAC(response.data))
        } else {
            yield errorGenerator(response)
        }

    } else {
        yield errorGenerator(responseAdd)
    }

    yield put(settingsSetCallbackLoaderAC(false))

}

export function* settingsAddCallbackWatcher () {
    yield takeLatest(settingsAddCallbackSagaAC.type, settingsAddCallbackWorker)
}




// ---------------------------------------------------------------------------------------------------------------------
// Saga delete callback
export function* settingsDeleteCallbackWorker (
    actionObject:{
        type: string,
        payload: {
            callbackId: string
        }
    }
) {

    yield put(settingsSetCallbackLoaderAC(true))

    let responseAdd = yield call(deleteCallback, { callbackId: actionObject.payload.callbackId })

    console.log('SAGA',responseAdd)

    if (responseAdd.status === 200) {

        yield notificationCreator('SUCCESS_DELETE_CALLBACK')

        let response = yield call(getCallbackList)
        console.log('SAGA', response.data)

        if (response.status === 200) {
            yield put(settingsSetCallbackDataAC(response.data))
        } else {
            yield errorGenerator(response)
        }

    } else {
        yield errorGenerator(responseAdd)
    }

    yield put(settingsSetCallbackLoaderAC(false))

}

export function* settingsDeleteCallbackWatcher () {
    yield takeLatest(settingsDeleteCallbackSagaAC.type, settingsDeleteCallbackWorker)
}



// ---------------------------------------------------------------------------------------------------------------------
// Saga edit callback
export function* settingsEditUrlCallbackWorker (
    actionObject:{
        type: string,
        payload: {
            callbackId: string,
            callbackUrl: string,
        }
    }
) {

    yield put(settingsSetCallbackLoaderAC(true))

    console.log('SAGA', actionObject.payload)

    let responseAdd = yield call(changeCallbackUrl, { callbackId: actionObject.payload.callbackId, callbackUrl: actionObject.payload.callbackUrl})

    if (responseAdd.status === 200) {

        yield notificationCreator('SUCCESS_EDIT_URL_CALLBACK')

        let response = yield call(getCallbackList)

        if (response.status === 200) {
            yield put(settingsSetCallbackDataAC(response.data))
        } else {
            yield errorGenerator(response)
        }

    } else {
        yield errorGenerator(responseAdd)
    }

    yield put(settingsSetCallbackLoaderAC(false))

}

export function* settingsEditUrlCallbackWatcher () {
    yield takeLatest(settingsEditUrlCallbackSagaAC.type, settingsEditUrlCallbackWorker)
}
